import { render, staticRenderFns } from "./Faturamentos.vue?vue&type=template&id=c0718d82&scoped=true&"
import script from "./Faturamentos.vue?vue&type=script&lang=js&"
export * from "./Faturamentos.vue?vue&type=script&lang=js&"
import style0 from "./Faturamentos.vue?vue&type=style&index=0&id=c0718d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0718d82",
  null
  
)

export default component.exports